import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import TokenVerification from './components/TokenVerification';
import ThankYou from './components/ThankYou';
import TeamLogin from './components/cllteam/login';
import ClientLogin from './components/ClientLogin';
import Register from './components/cllteam/Register';
import Header from './components/header';
import Navbar from './components/cllteam/navbar';
import OptionalDocumentsForm from './components/OptionalDocumentsForm';
//import UploadCases from './components/UploadCases';
import ClientSearch from './components/cllteam/ClientSearch';
import VideoPlayer from './components/Video';

const ApplicationRoutes = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {        
    return (
      <>
      <Navbar />
      <Routes>        
        <Route path="/" element={<TokenVerification />} />                      
        {/* <Route path="/sample-pack" element={<a href="/sample_pack.pdf" target="_blank" rel="noopener noreferrer">Download Sample Pack</a>} />               */}
        {/* <Route path="/upload-cases" element={<UploadCases />} /> */}
        <Route path="/push-email" element={<ClientSearch />}/>
        <Route path="/optional-documents" element={<OptionalDocumentsForm />} />
        <Route path="/explainer-video" element={<VideoPlayer />} />
        {/* <Route path="*" element={<UploadCases />} /> */}
      </Routes>
      </>
    )
  } else {
    return (
      <Routes>
        <Route path="/" element={<TokenVerification />} />     
        <Route path="/optional-documents" element={<OptionalDocumentsForm />} />   
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/login" element={<ClientLogin />} />
        
        <Route path="/register" element={<Register />} />
        <Route path="/team-login" element={<TeamLogin />} />        
        <Route path="/explainer-video" element={<VideoPlayer />} />
        <Route path="*" element={<ClientLogin />} />
        
      </Routes>
    )
  }  
}


const App = () => {
  return (    
    <>
      <Header />      
      <div className="App">
        <AuthProvider>
          <Router>
            <ApplicationRoutes />
          </Router>
        </AuthProvider>        
      </div>    
    </>
  );
};

export default App;
